import ChatBubbleOutlineOutlined from "@mui/icons-material/ChatBubbleOutlineOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";
import GroupOutlined from "@mui/icons-material/GroupOutlined";
import SendOutlined from "@mui/icons-material/SendOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";

const SendSMSPage = lazy(() => import("pages/messaging/send-sms/SendSMSPage"));
const SendGroupMessagePage = lazy(
  () => import("pages/messaging/send-to-groups/SendGroupMessagePage"),
);
const CustomSMSPage = lazy(
  () => import("pages/messaging/custom-sms/CustomSMSPage"),
);

const messagingRoutes: Array<Page | PageGroup> = [
  {
    segment: "messaging",
    title: "Messaging",
    Icon: ChatBubbleOutlineOutlined,
    children: [
      {
        segment: "send-sms",
        title: "Send SMS",
        Icon: SendOutlined,
        Component: SendSMSPage,
      },
      {
        segment: "send-to-groups",
        title: "Send to Groups",
        Icon: GroupOutlined,
        Component: SendGroupMessagePage,
      },
      {
        segment: "custom-sms",
        title: "Custom SMS",
        Icon: EditOutlined,
        Component: CustomSMSPage,
      },
    ],
  },
];

export default messagingRoutes;
